const CuentaConfirmada = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-3xl font-bold text-green-600 mb-4">¡Cuenta confirmada!</h1>
      <p className="text-lg text-gray-700">Ahora puedes iniciar sesión en la plataforma.</p>
    </div>
  );
};

export default CuentaConfirmada;
